const locale = {
	heroTitle: '瑞士型走心式車床精密加工專家',
	heroSubtitle: 'Cincom L20 走心機・φ1–20mm 小徑精密件・醫療・連接器・航太',
	heroCtaProducts: '查看產品',
	heroCtaContact: '立即詢價',
	featuresTitle: '我們的優勢',
	feature1Title: '瑞士型走心機（Cincom L20）',
	feature1Desc:
		'配備 Citizen Cincom L20 瑞士型走心式 CNC 車床，專精直徑 φ1–20mm 小型精密零件加工，可穩定達到 ±0.005mm 高精度公差。走心機特別適合細長軸、醫療探針、連接器接腳、航太緊固件等需要高長徑比或超高精度的零件。材質涵蓋不鏽鋼、鋁合金、銅、鈦合金、碳鋼及工程塑膠，支援單件打樣至批量生產。',
	feature2Title: '全製程整合',
	feature2Desc:
		'擎億提供從圖面設計、工程開發、CNC 走心加工，到後段表面處理的一站式服務，涵蓋研磨、拋光、陽極處理、電鍍（鍍鎳、鍍鉻、鍍鋅）、噴砂等完整製程。客戶只需提供圖面或樣品，其餘交由擎億全程負責，大幅節省跨廠協調時間，有效縮短整體交期，降低管理成本。',
	feature3Title: 'ISO 9001 認證',
	feature3Desc:
		'擎億通過 ISO 9001:2015 品質管理系統國際認證，建立標準化的生產作業流程與完整的品質追溯機制。每批產品出貨前均進行嚴格的尺寸量測（三次元 CMM 量測）與外觀檢驗，並保留完整的生產記錄與檢驗報告。持續的製程改善與品管稽核，確保每一件交付品皆符合客戶規格與國際品質標準。',
	aboutTitle: '關於擎億精密',
	about:
		'擎億精密有限公司創立於台灣新北市，專注於瑞士型走心式 CNC 精密加工，配備 Citizen Cincom L20 走心機，專精 φ1–20mm 小徑精密零件製造。服務範圍涵蓋產品設計、工程開發、技術繪圖，以及 CNC 加工後的研磨、拋光、電鍍等完整後製程，提供客戶一站式的精密製造解決方案。\n\n因應醫療器材、連接器、航太緊固件、電子設備、手錶機芯等各產業對小徑精密件的需求，擎億能夠根據客戶圖面或樣品進行高精度客製化生產，公差穩定達到 ±0.005mm。憑藉 ISO 9001 認證的嚴謹品管制度，以及持續精進的走心加工技術，我們持續為客戶交付尺寸精準、品質穩定、準時到貨的精密零件，是您可長期信賴的台灣精密製造夥伴。\n\n在材質應用上，擎億熟稔不鏽鋼（SUS）、黃銅、紫銅、鋁合金與工程塑膠等多元加工，並可搭配熱處理與各式表面處理；從少量打樣、試量產到大批量交貨，皆維持一致的尺寸精度與表面品質。自進料檢驗、製程巡檢到出貨全尺寸檢測，每道工序均完整紀錄可追溯，輔以彈性的產能調度與即時的工程溝通，協助客戶縮短開發週期、加速產品上市。我們始終相信「品質源於細節」，以專業與誠信，與每一位客戶建立長期穩定的合作關係。',
	isoTitle: 'ISO 9001 品質管理系統驗證',
	isoClick: '點擊查看證書',
	mineralsTitle: '負責任礦產採購政策',
	mineralsClick: '點擊查看政策',
	servicesTitle: '核心服務',
	services: [
		'產品設計',
		'工程開發',
		'技術繪圖',
		'CNC 走心加工',
		'研磨',
		'拋光',
		'電鍍',
		'CMM 品質檢驗'
	],
	stats: [
		{ value: 'Cincom L20', label: '瑞士型走心機' },
		{ value: 'φ1–20mm', label: '加工直徑範圍' },
		{ value: '±0.005mm', label: '穩定公差' },
		{ value: 'ISO 9001', label: '品質認證' }
	],
	milestonesTitle: '發展歷程',
	milestonesSubtitle: '持續精進，穩健成長',
	milestones: [
		{
			year: '2021',
			title: '官方網站建置上線',
			desc: '建立繁中／簡中／英文三語官方網站，導入線上產品展示與行動裝置瀏覽支援，讓國內外客戶都能即時了解擎億的加工能力。'
		},
		{
			year: '2022',
			title: '導入數據化營運',
			desc: '整合 Google Analytics 4，掌握客戶來源與瀏覽行為，持續優化數位行銷與服務體驗。'
		},
		{
			year: '2024',
			title: '通過 ISO 9001:2015 認證',
			desc: '取得國際品質管理系統驗證，建立標準化生產流程與完整品質追溯機制，為客戶交付穩定品質。'
		},
		{
			year: '2026',
			title: '網站全面改版',
			desc: '重新設計使用介面與內容，強化 SEO 與品牌形象，完整呈現 Cincom L20 走心機與小徑精密件實力。'
		},
		{
			year: '2026',
			title: '發布負責任礦產採購政策',
			desc: '響應 RBA 與 OECD 規範，公開承諾落實供應鏈無衝突礦產管理，與客戶共同善盡企業責任。'
		}
	],
	productsTitle: '精選產品',
	productsSubtitle: 'Cincom L20 走心機精密加工件',
	viewAllProducts: '查看全部產品',
	specsTitle: '設備規格',
	spec2Lbl: '小徑精密加工範圍',
	spec3Lbl: '精度公差',
	specTblDiameter: '最大加工直徑',
	specTblLength: '最大加工長度（單次夾持）',
	specTblSpindle: '主軸轉速',
	specTblRotaryTool: '旋轉刀具轉速',
	specTblTools: '最大刀具數',
	specTblLFV: 'LFV 切屑控制',
	specTblLFVVal: '正反面皆支援',
	pageTitle: '擎億精密有限公司 | 瑞士型走心機 CNC 精密加工',
	pageDesc: '擎億精密配備 Citizen Cincom L20 瑞士型走心式 CNC 車床，專精 φ1–20mm 小徑精密零件，公差 ±0.005mm，ISO 9001:2015 認證，服務醫療、連接器、航太產業。',
	pageKeywords: '瑞士型車床, 走心機, Cincom L20, 精密加工, 小徑零件, 醫療零件, 連接器加工, 航太零件, 台灣製造, ISO9001, 擎億精密, 新北市',
	contactTitle: '聯絡我們',
	address: '新北市樹林區備內街1巷35弄5號',
	phone: '0966-686-161 ／ 02-8687-2058',
	fax: '02-8687-2059',
	email: 'qingyi106@gmail.com'
};

export default locale;
